import Permissions from '@/security/permissions';
import PermissionChecker from '@/modules/iam/permission-checker';

export class GuidePermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.guideRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.guideImport,
    );
    this.guideAutocomplete = permissionChecker.match(
      Permissions.values.guideAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.guideCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.guideEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.guideDestroy,
    );
  }
}
